export default __webpack_public_path__ + "static/media/inheritage_icon.63ad104d.svg";